import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import store from './store'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
import './assets/style/main.css'
import './services/axios-config'  // Инициализируем axios interceptors
import 'bootstrap/dist/css/bootstrap.min.css'

const pinia = createPinia()
pinia.use(createPersistedState())

const app = createApp(App)
app.use(store).use(pinia).use(router).provide('bootstrap', bootstrap)

// Загружаем конфигурацию региона и города пользователя до монтирования,
// только если пользователь уже авторизован (есть access-токен в localStorage)
const storedUser = JSON.parse(localStorage.getItem('user') || 'null')
const hasAccessToken = storedUser?.access

if (hasAccessToken) {
  // Загружаем города, затем конфиг (с авто-выбором если город один)
  store.dispatch('config/loadUserCities').then(async () => {
    const cities = store.state.config.userCities
    if (cities.length === 1 && !store.state.config.selectedCityId) {
      await store.dispatch('config/selectCity', cities[0].id)
    } else {
      await store.dispatch('config/loadRegionConfig')
    }
  }).finally(() => {
    app.mount('#app')
  })
} else {
  app.mount('#app')
}
